/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import _ from 'underscore';
import $ from "jquery";
import logger from 'js-sdk/src/common/logging/logger';
import jasperserverMessages from '../../../../../i18n/jasperserver_messages.properties';
import DashboardBundle from '../../../../../i18n/DashboardBundle.properties';
import dashboardSettings from "../../../../dashboardSettings";
import Report from "bi-report/src/bi/report/Report";
import sandboxFactory from "../../../../factory/sandboxFactory";
import PaginationView from "js-sdk/src/common/component/pagination/Pagination";
import defaultLinkOptions from "../../../../hyperlink/defaultLinkOptions";
import scaleStrategies from "bi-report/src/bi/report/enum/scaleStrategies";
import AdHocView from "bi-adhoc/src/bi/adhoc/AdHocView";
import ReactDOM from "react-dom";
import WebPageView from "js-sdk/src/common/component/webPageView/WebPageView";
import hyperlinkTypes from "bi-report/src/bi/report/jive/enum/hyperlinkTypes";

let log = logger.register("componentTraitUtil");
let i18n = Object.assign({}, jasperserverMessages, DashboardBundle);
const exportOptions = [
    {
        label: i18n['jasper.report.view.hint.export.pdf'],
        action: 'pdf',
        params: {outputFormat: "pdf"}
    },
    /*{
        label: i18n['jasper.report.view.hint.export.excel'],
        action: 'excel',
        params: {outputFormat: "xls"}
    },
    {
        label: i18n['jasper.report.view.hint.export.excel.nopag'],
        action: 'excel.nopag',
        params: {outputFormat: "xls", ignorePagination: true}
    },*/
    {
        label: i18n['jasper.report.view.hint.export.rtf'],
        action: 'rtf',
        params: {outputFormat: "rtf"}
    },
    {
        label: i18n['jasper.report.view.hint.export.csv'],
        action: 'csv',
        params: {outputFormat: "csv"}
    },
    {
        label: i18n['jasper.report.view.hint.export.odt'],
        action: 'odt',
        params: {outputFormat: "odt"}
    },
    {
        label: i18n['jasper.report.view.hint.export.ods'],
        action: 'ods',
        params: {outputFormat: "ods"}
    },
    {
        label: i18n['jasper.report.view.hint.export.docx'],
        action: 'docx',
        params: {outputFormat: "docx"}
    },
    {
        label: i18n['jasper.report.view.hint.export.xlsx'],
        action: 'xlsx',
        params: {outputFormat: "xlsx"}
    },
    {
        label: i18n['jasper.report.view.hint.export.xlsx.nopag'],
        action: 'xlsx.nopag',
        params: {outputFormat: "xlsx", ignorePagination: true}
    },
    {
        label: i18n['jasper.report.view.hint.export.pptx'],
        action: 'pptx',
        params: {outputFormat: "pptx"}
    }
];

function checkTabExport(chartType, type) {
    if (type === 'table' || type === 'crosstab') {
        if (chartType.toLowerCase() !== type) {
            this.toolbar && this.toolbar.getOptionView("export").disable();
        }
        else {
            this.toolbar && this.toolbar.getOptionView("export").enable();
            this.updatedChartType = null;
        }
    } else if (chartType === 'Table' || chartType === 'Crosstab') {
        this.toolbar && this.toolbar.getOptionView("export").disable();
    } else {
        this.toolbar && this.toolbar.getOptionView("export").enable();
    }
}

function processLinkOptions(AdhocView) {
    if (!AdhocView) {
        return;
    }
    var linkOptions = this.dashboardId  ? (sandboxFactory.get(this.dashboardId).get("linkOptions") || {}) : {},
        processedOptions = { events: {} },
        self = this;

    for (var e in linkOptions.events) {
        processedOptions.events[e] = function (ev, link) {
            var eventName = ev.eventType === "jr_hyperlink_interception" ? "click" : ev.type.toLowerCase();
            linkOptions.events[eventName] && linkOptions.events[eventName].call(self.component, ev, {
                parameters: link,
                type: hyperlinkTypes.ADHOC_EXECUTION
            }, _.bind(defaultLinkOptions.events[eventName], self.component, ev, {
                parameters: link,
                type: hyperlinkTypes.ADHOC_EXECUTION
            }, self));
        }
    }

    for (var event in defaultLinkOptions.events) {
        if (!processedOptions.events.hasOwnProperty(event)) {
            processedOptions.events[event] = function (ev, link) {
                var eventName = ev.eventType === "jr_hyperlink_interception" ? "click" : ev.type.toLowerCase();

                if (defaultLinkOptions.events[eventName]) {
                    defaultLinkOptions.events[eventName].call(self.component, ev, {
                        parameters: link,
                        type: hyperlinkTypes.ADHOC_EXECUTION
                    }, self);
                }

            }
        }
    }
    processedOptions.beforeRender = function(pairs) {
        defaultLinkOptions.discoverHyperlinkHandlers(pairs).done(function() {
            if (linkOptions.beforeRender) {
                linkOptions.beforeRender.call(self.component, pairs, _.bind(defaultLinkOptions.beforeRender, self.component, pairs, self));
            } else {
                defaultLinkOptions.beforeRender.call(self.component, pairs, self);
            }
        });
    };
    return processedOptions;
}

function onReportCompleted(paginationView) {
    try {
        // if pagination was changed not through pagination control, but through another source (e.g. hyperlink),
        // we need to sync up pagination control with report
        if (!_.isUndefined(this.pages()) && paginationView && paginationView.model && this.pages() !== paginationView.model.get("current")) {
            const page = parseInt(_.isObject(this.pages()) ? this.pages().pages : this.pages(), 10);

            !isNaN(page) && paginationView.model.set("current", page);
        }
    } catch (ex) {
        // ignore "already.destroyed.error"
        if (ex.errorCode !== "already.destroyed.error") {
            log.error(ex.toString());
        }
    }
}

function onTotalPagesChange(totalPages) {
    if (totalPages > 1) {
        !this.paginationView
            ? _initPagination.call(this, {total: totalPages})
            : this._refreshPagination(totalPages);
    } else {
        this.paginationView && this.paginationView.hide();
    }
}

function _initPagination(options) {
    let pagination = this.paginationView = new PaginationView(options);

    _initPaginationEvents.call(this, pagination);

    this.$content.before(pagination.render().$el);

    !this.model.get("showPaginationControl") && pagination.hide();
}

function _initPaginationEvents(paginationView) {
    let self = this;

    this.listenTo(paginationView, "pagination:change", function (currentPage) {
        let report;
        if (self.replaceComponent && self.replaceComponent instanceof Report) {
            report = self.replaceComponent;
        } else if (self.drilldownComponent && self.drilldownComponent instanceof Report) {
            report = self.drilldownComponent;
        } else {
            report = self.component;
        }
        if (!self.isPageChangingWhileReportIsRunning) {
            self.isPageChangingWhileReportIsRunning = this.isReportRunning;
        }

        report.pages(currentPage).run().done(_.bind(function () {
            // when event firing is off we still need to update pagination input.
            paginationView.options.silent && paginationView.$el.find(".current").val(currentPage);
        }, this)).fail(_.bind(function () {
            paginationView.model.set("current", paginationView.model.defaults.current);
        }, this)).always(_.bind(this._onReportRunFinished, this));
    });
}

function findJrPageTable($content) {
    //in phantomjs search by selector: this.$content.find("table.jrPage")
    //for some reason is not working, so we have to manually check classes
    const tableEl = $content.find("table")[0];
    const className = tableEl && tableEl.className;
    const isJrPage = className && className.indexOf("jrPage") >= 0;

    return isJrPage ? $(tableEl) : null;
}

function getScaleFactor(scaleStrategy, jrWidth, jrHeight, cWidth, cHeight) {
    let scale;
    if (scaleStrategy === scaleStrategies.WIDTH) {
        scale = cWidth / jrWidth;
    } else if (scaleStrategy === scaleStrategies.HEIGHT) {
        scale = cHeight / jrHeight;
    } else {
        let scaleV = cWidth / jrWidth, scaleH = cHeight / jrHeight;
        scale = (scaleV * jrHeight) < cHeight ? scaleV : scaleH;
    }

    return scale;
}


const compTraitUtil = {
    extractExecutionParams: function (replaceInfo) {
        let params;
        const fromProps = _.reduce(this.model.get("parameters"), function (memo, parameter) {
            if (parameter.parametrizeProperty) {
                memo.push(parameter.id);
            }
            return memo;
        }, []);
        params = !_.isEmpty(replaceInfo) ? replaceInfo : this.paramsModel.attributes;
        _.each(params, function (value, key, obj) {
            if (!value || (value.length && value[0] === "total_node")) {
                value = [];
            }
            obj[key] = value;
        });
        return _.omit(params, fromProps);
    },
    processLinkOptions: function (report) {
        if (!report) {
            return;
        }

        const linkOptions = this.dashboardId ? (sandboxFactory.get(this.dashboardId).get("linkOptions") || {}) : {},
            processedOptions = {events: {}},
            self = this;

        for (const event in linkOptions.events) {
            processedOptions.events[event] = function (ev, link) {
                const eventName = ev.eventType === "jr_hyperlink_interception" ? "click" : ev.type.toLowerCase();

                linkOptions.events[eventName] && linkOptions.events[eventName].call(self.component, ev, link, _.bind(defaultLinkOptions.events[eventName], self.component, ev, link, self));
            }
        }

        for (const defaultLinkOptionsEvent in defaultLinkOptions.events) {
            if (!processedOptions.events.hasOwnProperty(defaultLinkOptionsEvent)) {
                processedOptions.events[defaultLinkOptionsEvent] = function (ev, link) {
                    const eventName = ev.eventType === "jr_hyperlink_interception" ? "click" : ev.type.toLowerCase();

                    defaultLinkOptions.events[eventName] && defaultLinkOptions.events[eventName].call(self.component, ev, link, self);
                }
            }
        }

        processedOptions.beforeRender = function (pairs) {
            defaultLinkOptions.discoverHyperlinkHandlers(pairs).done(function () {
                if (linkOptions.beforeRender) {
                    linkOptions.beforeRender.call(self.component, pairs, _.bind(defaultLinkOptions.beforeRender, self.component, pairs, self));
                } else {
                    defaultLinkOptions.beforeRender.call(self.component, pairs, self);
                }
            });
        };

        return processedOptions;
    },
    onReportFailedRun: function (errorObj) {
        if (errorObj.errorCode !== "report.execution.cancelled") {
            this.paginationView && this.paginationView.hide();
            this.$content.empty();
            this.showMessage(errorObj);
            compTraitUtil.enableBackButton.call(this);
            this.ready.resolve();
        }
    },
    convertHyperlinksParamsToVizJsApi: function (params) {
        let convertedParams = {};

        for (let param in params) {
            convertedParams[param] = _.isArray(params[param]) ? params[param] : [params[param]];
        }

        return convertedParams;
    },
    isAdhocChartReport: function (reportView) {
        return reportView.$("> .dashletContent > .content > ._jr_report_container_ > .highcharts_parent_container").length > 0;
    },
    createReportInstance: function (resourceUri, params, pages, callback) {
        let self = this,
            reportProps = {
                resource: resourceUri,
                container: this.$content,
                params: params,
                autoresize: false,
                server: dashboardSettings.CONTEXT_PATH,
                showAdhocChartTitle: true,
                scale: this.model.get("scaleToFit"),
                pages: ((_.isObject(pages) && _.isUndefined(pages.pages) && _.isUndefined(pages.anchor)) || _.isUndefined(pages)) ? 1 : pages,
                events: {
                    changeTotalPages: _.bind(onTotalPagesChange, self),
                    changePagesState: function (page) {
                        if (self.paginationView) {
                            self.paginationView.model.set("current", page);
                        } else {
                            !_.isUndefined(this.data().totalPages) && this.data().totalPages > 1 && _initPagination.call(self, {current: page});
                        }

                        // update pages of current component to match inner state of report
                        let oldPages = this.pages(),
                            newPages = _.isObject(oldPages) ? {pages: page} : page;

                        // do not loose anchor if it was set before
                        if (_.isObject(oldPages) && !_.isUndefined(oldPages.anchor)) {
                            newPages.anchor = oldPages.anchor;
                        }

                        this.pages(newPages);
                    },
                    reportCompleted: function () {
                        onReportCompleted.call(this, self.paginationView);
                    },
                    beforeRender: function () {
                        self.hideMessage();

                        if (self.component === this && (self.replaceComponent || self.drilldownComponent)) {
                            callback.call(self);

                            onTotalPagesChange.call(self, this.data().totalPages);
                            onReportCompleted.call(this, self.paginationView);
                        }
                    }
                },
                defaultJiveUi: {
                    floatingTableHeadersEnabled: true,
                    floatingCrosstabHeadersEnabled: true
                }
            };
        let report = new Report(reportProps);
        this.dashboardId && report.properties(sandboxFactory.get(this.dashboardId).get("reportSettings") || {});
        return report;
    },
    _calculateContentOverflow: function () {
        let overflowX = "auto";
        let overflowY = "auto";

        const jrPage = findJrPageTable.call(this, this.$content);

        const jrPageW = jrPage && jrPage.outerWidth();
        const jrPageH = jrPage && jrPage.outerHeight();

        const contentW = this.$content.outerWidth();
        const contentH = this.$content.outerHeight();

        const scaleStrategy = this.model.get("scaleToFit");

        const scaleFactor = scaleStrategy !== 1 ? getScaleFactor.call(this, scaleStrategy, jrPageW, jrPageH, contentW, contentH) : 1;

        (contentW >= Math.floor(jrPageW * scaleFactor)) && (overflowX = "hidden");
        (contentH >= Math.floor(jrPageH * scaleFactor)) && (overflowY = "hidden");

        return {
            overflowX: overflowX,
            overflowY: overflowY
        }

    },
    isDashletSelect: function () {
        const modelCollectionSelected = this.model.collection.lastSelectedDashlet;
        return !sandboxFactory.get(this.dashboardId).get('previewMode') && modelCollectionSelected && modelCollectionSelected.length && modelCollectionSelected.slice(-1)[0].id == this.model.get('id');
    },
    getScaleFactor: getScaleFactor,
    findJrPageTable: findJrPageTable,
    _initPagination: _initPagination,
    exportOptions: exportOptions,
    getParameters: function (model) {
        return _.reduce(model.get('outputParameters'), function (memo, param) {
            memo.parameters[param.id] = param.defaultValue;
            return memo;
        }, {parameters: {}});
    },
    triggerLinkOptions: function (ev, model) {
        const eventName = ev.type.toLowerCase();
        const linkOptions = model.dashboardId ? (sandboxFactory.get(model.dashboardId).get("linkOptions") || {}) : {};
        linkOptions.events && linkOptions.events[eventName] && linkOptions.events[eventName](ev, this.getParameters(model));
    },
    createAdhocViewInstance: function (resourceUri, params, attributes = {}) {
        return new AdHocView({
            resource: resourceUri,
            container: this.$content,
            allowDrilldown: !!attributes.enableAdhocDrilldown,
            params: params,
            autoresize: false,
            server: dashboardSettings.CONTEXT_PATH ? dashboardSettings.CONTEXT_PATH : window.location.origin,
            events: {
                onVisualizationTypeChange: (chartType) => {
                    if (this.component) {
                        this.replaceChartType = null;
                        this.updatedChartType = chartType;
                        this.model.updatedChartType = chartType;
                        checkTabExport.call(this, chartType, this.model.get('type'));
                    } else if (this.replaceComponent) {
                        this.replaceChartType = chartType;
                        this.model.updatedChartType = chartType;
                    }
                },
                onDrilldown: (info) => {
                    this.model.drilldownInfo = info;
                }
            }
        });
    },
    onAdhocSuccessfulRun: function (triggerComponentRendered, toggleVizIcon) {
        this.hideMessage();
        this._resizeComponent();
        toggleVizIcon.call(this);
        triggerComponentRendered !== false && this.trigger("componentRendered", self);
        compTraitUtil.enableBackButton.call(this);
    },
    enableBackButton: function () {
        this.toolbar && this.toolbar.$el.find('.hyperlinkBackbutton').prop('disabled', false).removeClass('disabled');
    }, onAdhocFailedRun: function (errorObj) {
        if (errorObj.errorCode) {
            let errorContainer = this.$content.find('.jr-mMessageError');
            errorContainer.length ? errorContainer.parent().hide() : this.$content.empty();
            errorObj.errorCode = 'adhoc.' + errorObj.errorCode;
            this.showMessage(errorObj);
            this.trigger("componentRendered", this);
            compTraitUtil.enableBackButton();
            this.ready.resolve();
        }
    },
    destroyReplaceComponent: function () {
        if (this.replaceComponent) {
            ReactDOM.unmountComponentAtNode(this.$content[0]);
            this.replaceComponent instanceof WebPageView ? this.replaceComponent.remove() : this.replaceComponent.destroy();
            this.replaceComponent = null;
            this.paginationView && this.paginationView.hide();
        }
    },
    back: function () {
        this.model.set('isReplacedHyperlink', false);
        for (let param in this.model.paramsModel.attributes) {
            this.model.paramsModel.unset(param);
        }
        this.model.paramsModel.set(this.parameterBeforeReplace);
        this.model.collection.getDashboardPropertiesComponent().applyParameters();
        this.model.updatedChartType = null;
        this.model.reportExecutionId = null;
    },
    updateToolbarBackButton: function() {
        this.toolbar && this.toolbar.getOptionView("export").disable();
        this.toolbar && this.toolbar.$el.find('.hyperlinkBackbutton').prop('disabled', true).addClass('disabled');
        if (this.toolbar && !this.model.get('isReplacedHyperlink')) {
            this.toolbar.$el.find('.hyperlink').css('display', 'none');
            this.toolbar.$el.find('.hyperlinkBackbutton').parent().removeClass('hyperlink');
        }
    },
    replaceParameterGrammer: function (url, target, hasParamGrammer) {
        let paramGrammerInfo, val, self;
        self = this;
        if (hasParamGrammer) {
            this.model.getLinkUrl(this.model.paramsModel.attributes).done(function (data) {
                paramGrammerInfo = data;
                paramGrammerInfo && compTraitUtil.extractExecutionParams.call(self, paramGrammerInfo.parameters);
            });
        }
        if (!_.isEmpty(this.model.paramsModel.attributes) && this.paramsModel.paramsChanged) {
            compTraitUtil.extractExecutionParams.call(self);
            this.model.collection.pushParametersState();
            for (let param in this.model.paramsModel.attributes) {
                this.model.paramsModel.unset(param, {silent: true});
            }
        }
        val = {
            target: target,
            resource: paramGrammerInfo ? paramGrammerInfo.uri : url.replace(/^repo:/, ""),
            parameters: paramGrammerInfo ? paramGrammerInfo.parameters : {}
        };
        this.model.paramsModel.set(val);
    },
    _resetContentOverflow: function(overflow){
        const contentOverflow = overflow || {};
        this.$content.css({
            "overflow-x": contentOverflow.overflowX || "auto",
            "overflow-y": contentOverflow.overflowY || "auto"
        });
    },

    updateReportLinkOptions: function() {
        this.component && this.component.linkOptions && this.component.linkOptions(compTraitUtil.processLinkOptions.call(this, this.component) || {});
        this.drilldownComponent && this.drilldownComponent instanceof Report
        && this.drilldownComponent.linkOptions(compTraitUtil.processLinkOptions.call(this, this.drilldownComponent) || {});
        this.replaceComponent && this.replaceComponent instanceof Report
        && this.replaceComponent.linkOptions && this.replaceComponent.linkOptions(compTraitUtil.processLinkOptions.call(this, this.replaceComponent) || {});
    },
    updateAdhocLinkOptions: function () {
        this.component && this.component.linkOptions && this.component.linkOptions(processLinkOptions.call(this, this.component) || {});
        this.replaceComponent && this.replaceComponent instanceof AdHocView
        && this.replaceComponent.linkOptions && this.replaceComponent.linkOptions(processLinkOptions.call(this, this.replaceComponent) || {});
    }
};
export default compTraitUtil;

